import React from 'react';
import { useAuthContext } from '../../features/auth/context/AuthContext';
import { useInfoModals } from '../../hooks/useInfoModals';
import InfoModal from './InfoModal';

const InfoModalProvider = ({ children }) => {
  const { user } = useAuthContext();
  const {
    currentModals,
    closeModals,
    handleModalComplete
  } = useInfoModals(user);

  return (
    <>
      {children}
      
      {/* Show info modals when available */}
      {currentModals.length > 0 && (
        <InfoModal
          modals={currentModals}
          onClose={closeModals}
          onComplete={handleModalComplete}
        />
      )}
    </>
  );
};

export default InfoModalProvider;